// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lTuZ9","type":"styles_type__2dpCb","choices":"styles_choices__1Hz10"};